import React, { Component } from 'react'
import { Card, CardHeader, CardBody, CardFooter, Row, Col } from 'reactstrap'
import values from 'mout/object/values'
import {
  Selector,
  AddButton,
  Header,
  Nav,
  SearchFilter,
} from './ManagePane'
import { InfoCards } from './ManagePane/InfoCard'
import queryString from 'query-string'
import { BeatLoader } from 'react-spinners'
import { ErrorMessage } from './ManagePane/InfoCard/ActionBlockComponents';

// Still need to fix!

class ManageUsersDistricts extends Component {
  state = {
    filter: ''
  }

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  render() {
    const { districts, schools, educators, match, user, history, location } = this.props
    const { filter } = this.state
    const qs = queryString.parse(location.search)
    const actionId = qs.r ? qs.r : ''

    return (
      <Card>
        {user && user.role === 'Super Administrator'
          ? <CardBody>
            <Row>
              <Col xs='12' sm='8' md='9' lg='10' xl='10'>
                <Header>Manage Districts</Header>
              </Col>
              <Col xs='12' sm='4' md='3' lg='2' xl='2'>
                <AddButton role='districts'>+ Add a District</AddButton>
              </Col>
            </Row>
            <SearchFilter
              placeholder='Search Districts...'
              filter={filter}
              handleChange={this.handleChange}
            />
            <InfoCards
              records={values(districts)}
              filter={filter}
              recordType='district'
              actionId={actionId}
              history={history}
              search={location.search}
              user={user}
            />
            <BeatLoader loading={!districts} />
            <AddButton role='districts'>+ Add a District</AddButton>
          </CardBody>
          : <CardBody>
            {user
              ? <ErrorMessage>Sorry! Your account does not have permission to access this page.</ErrorMessage>
              : <BeatLoader loading={true} />
            }
          </CardBody>
        }
        <CardFooter>
        </CardFooter>
      </Card>
    )
  }
}

export default ManageUsersDistricts


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageUsersDistricts.js